
export function xsrfConfig (iceXSRFProtectionProvider, $httpProvider) {
  'ngInject';

  const
    XSRF_RESPONSE_HEADER_NAME = 'X-APP-XSRF-TOKEN',   // CUSTOMIZE this name to prevent multiple app collisions: replace APP with custom name
    XSRF_REQUEST_HEADER_NAME = 'X-APP-XSRF-TOKEN',    // CUSTOMIZE this name to prevent multiple app collisions: replace APP with custom name
    XSRF_REQUEST_FORMPARAM_NAME = '_xsrf',            // Legacy form support. Use with  iceXSRFProtection.getRequestFormParamName()
    DEBUG = true
  ;

  iceXSRFProtectionProvider
    .setResponseHeaderName(XSRF_RESPONSE_HEADER_NAME)
    .setRequestHeaderName(XSRF_REQUEST_HEADER_NAME)
    .setRequestFormParamName(XSRF_REQUEST_FORMPARAM_NAME)
    .setDebugStatus(DEBUG);

  $httpProvider.interceptors.push('iceXSRFTokenHttpInterceptor');
}



// WEBPACK FOOTER //
// ./client/app/app.config/xsrf.config.js